"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 3 13" id=icon-overflow-small><path d="M1.5 10a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0-5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0-5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"></path></symbol>';
}